import app from 'flarum/common/app';
export default async function shareUrl(url, description) {
  try {
    await navigator.share({
      title: app.forum.attribute('title'),
      text: description,
      url
    });
  } catch (e) {
    if (e instanceof DOMException && e.name === 'AbortError') return;
    console.error(e);
  }
}
flarum.reg.add('davwheat-share', 'common/helpers/shareUrl', shareUrl);